
export const useCaptcha = (process.env.REACT_APP_USE_RECAPTCHA ?? false);
export const siteKey = (process.env.REACT_APP_RECAPTCHA_SITE_KEY ?? '');
export const secretKey = (process.env.REACT_APP_RECAPTCHA_SECRET_KEY ?? '');